var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 18,
  fill: "none",
  viewBox: "0 0 19 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.052.901a.5.5 0 0 1 .896 0l2.387 4.804a.5.5 0 0 0 .374.272l5.306.785a.5.5 0 0 1 .277.852l-3.831 3.754a.5.5 0 0 0-.143.44l.892 5.29a.5.5 0 0 1-.724.526L9.73 15.141a.5.5 0 0 0-.462 0l-4.755 2.483a.5.5 0 0 1-.724-.526l.892-5.29a.5.5 0 0 0-.143-.44L.71 7.615a.5.5 0 0 1 .276-.852l5.306-.785a.5.5 0 0 0 .375-.272z"
})));
export default SvgStar;